/* BNZ2 shared JS - ported from the r2 prototypes, with real Shopify cart wiring. */
(function () {
  /* reveal may only hide content while this script is alive */
  document.documentElement.classList.add('bnz-rv');

  /* dropdown windows: one open at a time, close on link tap + outside tap */
  document.querySelectorAll('details.nav-dd').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) document.querySelectorAll('details.nav-dd').forEach(function (o) { if (o !== d) o.open = false; });
    });
    d.querySelectorAll('.dd a').forEach(function (a) { a.addEventListener('click', function () { d.open = false; }); });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('details.nav-dd')) document.querySelectorAll('details.nav-dd').forEach(function (o) { o.open = false; });
  });
  document.querySelectorAll('a[href="#"]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); }); });

  /* ticker dismiss */
  var tkx = document.querySelector('.tk-x');
  if (tkx) tkx.addEventListener('click', function () {
    tkx.closest('.ticker').style.display = 'none';
    document.body.style.paddingBottom = document.querySelector('.mbb') ? '96px' : '8px';
  });

  /* live cart count */
  window.bnz2CartCount = function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-n').forEach(function (n) { n.textContent = c.item_count; });
    }).catch(function () {});
  };
  window.bnz2CartCount();

  window.bnzThumb = function (url) {
    if (!url) return null;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  };
  var bnzThumb = window.bnzThumb;

  /* grid cards: two steps, never an auto-add.
     step 1 - a chip click only SELECTS the size and reveals QUICK BUY.
     step 2 - only the QUICK BUY pill adds the selected variant to cart. */
  function bnzCollapseCards(except) {
    document.querySelectorAll('.card.sel').forEach(function (card) {
      if (card === except) return;
      card.classList.remove('sel');
      card.querySelectorAll('.chip').forEach(function (x) { x.classList.remove('on', 'added'); });
      var q = card.querySelector('.qbuy');
      if (q) { q.textContent = 'QUICK BUY'; q.setAttribute('aria-hidden', 'true'); q.setAttribute('tabindex', '-1'); }
      card.removeAttribute('data-selected-variant');
    });
  }

  document.querySelectorAll('.card').forEach(function (card) {
    var chips = card.querySelector('.chips');
    var qbuy = card.querySelector('.qbuy');
    if (!chips || !qbuy) return;

    chips.addEventListener('click', function (e) {
      var chip = e.target.closest('.chip'); if (!chip) return;
      e.preventDefault(); e.stopPropagation();
      var vid = chip.getAttribute('data-variant-id'); if (!vid) return;
      bnzCollapseCards(card);
      var wasOn = chip.classList.contains('on');
      chips.querySelectorAll('.chip').forEach(function (x) { x.classList.remove('on', 'added'); });
      if (wasOn) {
        card.classList.remove('sel');
        card.removeAttribute('data-selected-variant');
        qbuy.textContent = 'QUICK BUY';
        qbuy.setAttribute('aria-hidden', 'true');
        qbuy.setAttribute('tabindex', '-1');
        return;
      }
      chip.classList.add('on');
      card.classList.add('sel');
      card.setAttribute('data-selected-variant', vid);
      qbuy.textContent = 'QUICK BUY ' + chip.textContent.trim();
      qbuy.setAttribute('aria-hidden', 'false');
      qbuy.setAttribute('tabindex', '0');
    });

    function bnzAdd(e) {
      e.preventDefault(); e.stopPropagation();
      var vid = card.getAttribute('data-selected-variant'); if (!vid) return;
      if (qbuy.getAttribute('data-busy') === '1') return;
      qbuy.setAttribute('data-busy', '1');
      qbuy.textContent = 'ADDING';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (item) {
          qbuy.textContent = 'ADDED';
          card.querySelectorAll('.chip.on').forEach(function (x) { x.classList.add('added'); });
          window.bnz2CartCount();
          var prEl = card.querySelector('.pr');
          if (window.bnz2AddedWindow) window.bnz2AddedWindow({
            title: item.product_title || item.title,
            variant: item.variant_title || '',
            price: prEl ? prEl.textContent.trim() : '',
            image: bnzThumb(item.image)
          });
          setTimeout(function () { qbuy.removeAttribute('data-busy'); bnzCollapseCards(null); }, 1400);
        })
        .catch(function () {
          qbuy.textContent = 'TRY AGAIN';
          qbuy.removeAttribute('data-busy');
        });
    }
    qbuy.addEventListener('click', bnzAdd);
    qbuy.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') bnzAdd(e);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.card.sel')) bnzCollapseCards(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !document.querySelector('.pwin')) bnzCollapseCards(null);
  });

  /* scroll reveal - the story unravels; fail-open, reduced-motion handled in CSS */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }
  function bnzRevealSafety(margin) {
    document.querySelectorAll('.rv:not(.in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * margin) el.classList.add('in');
    });
  }
  window.addEventListener('load', function () { bnzRevealSafety(1); });
  setTimeout(function () { bnzRevealSafety(1.5); }, 2500);
  /* scroll-driven safety net: nothing stays invisible once it has been on screen */
  var rvTick = false;
  window.addEventListener('scroll', function () {
    if (rvTick) return; rvTick = true;
    requestAnimationFrame(function () { rvTick = false; bnzRevealSafety(1); });
  }, { passive: true });

  /* size charts and other rich-text art open in the photo window (item 15) */
  document.querySelectorAll('.rte img, .shopify-policy__body img').forEach(function (img) {
    if (img.hasAttribute('data-full')) return;
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src) return;
    var full = src.replace(/([?&])width=\d+/, '$1width=2000');
    if (full === src) full = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2000';
    img.setAttribute('data-full', full);
    img.style.cursor = 'zoom-in';
  });

  /* events filter pills */
  document.querySelectorAll('.fpill').forEach(function (f) {
    f.addEventListener('click', function () {
      document.querySelectorAll('.fpill').forEach(function (x) { x.style.background = ''; x.style.color = ''; });
      f.style.background = '#0A0A0A'; f.style.color = '#fff';
      var k = f.getAttribute('data-f');
      document.querySelectorAll('.evw').forEach(function (w) { w.classList.toggle('hide', k !== 'all' && !w.classList.contains(k)); });
    });
  });

  /* cart line changes: qty steppers + remove. Drives /cart/change.js and
     re-renders the cart section from the response, so the header badge and
     the totals never go stale after a removal. */
  function bnzCartRerender(data) {
    var root = document.querySelector('[data-cart-root]');
    var id = root && root.getAttribute('data-section-id');
    var html = data && data.sections && id ? data.sections[id] : null;
    if (html && root) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-root]');
      if (fresh) {
        root.replaceWith(fresh);
        fresh.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
        window.bnz2CartCount();
        return true;
      }
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]'); if (!b) return;
    e.preventDefault();
    if (b.getAttribute('data-busy') === '1') return;
    b.setAttribute('data-busy', '1');
    var root = document.querySelector('[data-cart-root]');
    var id = root && root.getAttribute('data-section-id');
    var body = { line: parseInt(b.getAttribute('data-line-change'), 10), quantity: parseInt(b.getAttribute('data-qty'), 10) };
    if (id) { body.sections = id; body.sections_url = window.location.pathname; }
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (data) {
        window.bnz2CartCount();
        if (!bnzCartRerender(data)) window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  });

  /* post-add window: never dead-end after ADDED. Reuses the photo-window
     chrome - added item, VIEW CART, CHECKOUT, x. */
  window.bnz2AddedWindow = function (info) {
    document.querySelectorAll('.pwin.addwin').forEach(function (w) { w.remove(); });
    var win = document.createElement('div');
    win.className = 'win pwin addwin' + (pwTouch() ? ' pw-mob' : '');
    win.setAttribute('tabindex', '0');
    var img = info.image ? '<img src="' + info.image + '" alt="" width="88" height="110">' : '';
    win.innerHTML =
      '<div class="win-bar pw-bar"><span class="pw-t">ADDED TO CART</span>' +
        '<span class="pw-ctl"><button class="pw-b" type="button" data-a="close" aria-label="Close">&#10005;</button></span></div>' +
      '<div class="add-body">' + img +
        '<div class="add-txt">' +
          '<span class="add-nm"></span>' +
          '<span class="add-var"></span>' +
          '<span class="add-pr"></span>' +
        '</div>' +
      '</div>' +
      '<div class="add-act">' +
        '<a class="pill" href="/cart">VIEW CART</a>' +
        '<a class="pill crimson" href="/checkout">CHECKOUT &#8594;</a>' +
      '</div>';
    win.querySelector('.add-nm').textContent = info.title || '';
    win.querySelector('.add-var').textContent = info.variant || '';
    win.querySelector('.add-pr').textContent = info.price || '';
    /* No inline placement - CSS pins this to the viewport, top right, under the
       cart it refers to. Inline left/top would fight that and reintroduce the
       scroll-dependent positioning. */
    document.body.appendChild(win);
    pwFront(win);
    /* pwFront hands out z-indexes from 41, which sits under the sticky header
       (90) and the ticker (99). Lift the confirmation above both. */
    win.style.zIndex = 130;
    win.focus({ preventScroll: true });
    win.addEventListener('click', function (e) {
      if (e.target.closest('[data-a="close"]')) { e.preventDefault(); win.remove(); }
    });
    return win;
  };

  /* myspace photo windows: click a gallery photo, it opens enlarged in a
     floating OS-window. Draggable by the bar on desktop, fixed and swipeable
     on touch. Prev/next walk that gallery, x closes, Escape closes topmost. */
  var pwZ = 40, pwN = 0;
  function pwTouch() {
    if (window.matchMedia('(hover:none)').matches) return true;
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    return w > 0 && w <= 820;
  }
  function pwFront(win) { pwZ += 1; win.style.zIndex = pwZ; }

  function pwPaint(win) {
    var shots = win.pwShots, i = win.pwIdx;
    win.querySelector('.pw-img img').src = shots[i].full;
    win.querySelector('.pw-img img').alt = shots[i].alt || '';
    win.querySelector('.pw-t').textContent = win.pwTitle + ' - ' + (i + 1) + '/' + shots.length;
    var multi = shots.length > 1;
    win.querySelectorAll('[data-a="prev"],[data-a="next"]').forEach(function (b) { b.style.display = multi ? '' : 'none'; });
  }

  function pwStep(win, d) {
    var n = win.pwShots.length;
    win.pwIdx = (win.pwIdx + d + n) % n;
    pwPaint(win);
  }

  function pwClose(win) { win.remove(); }

  function pwOpen(shots, idx, title) {
    var win = document.createElement('div');
    win.className = 'win pwin' + (pwTouch() ? ' pw-mob' : '');
    win.setAttribute('tabindex', '0');
    win.innerHTML =
      '<div class="win-bar pw-bar">' +
        '<span class="pw-t"></span>' +
        '<span class="pw-ctl">' +
          '<button class="pw-b" type="button" data-a="prev" aria-label="Previous photo">&#8249;</button>' +
          '<button class="pw-b" type="button" data-a="next" aria-label="Next photo">&#8250;</button>' +
          '<button class="pw-b" type="button" data-a="close" aria-label="Close">&#10005;</button>' +
        '</span>' +
      '</div>' +
      '<div class="pw-img"><img src="" alt=""></div>';
    win.pwShots = shots; win.pwIdx = idx; win.pwTitle = title;

    if (!pwTouch()) {
      var off = (pwN % 6) * 26;
      win.style.left = Math.max(8, Math.round(window.innerWidth * 0.5 - 320) + off) + 'px';
      win.style.top = Math.max(8, Math.round(window.scrollY + 70) + off) + 'px';
    }
    pwN += 1;
    document.body.appendChild(win);
    pwPaint(win);
    pwFront(win);
    win.focus();

    win.addEventListener('pointerdown', function () { pwFront(win); });
    win.addEventListener('click', function (e) {
      var b = e.target.closest('.pw-b'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var a = b.getAttribute('data-a');
      if (a === 'close') pwClose(win);
      else pwStep(win, a === 'next' ? 1 : -1);
    });
    win.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); pwStep(win, 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); pwStep(win, -1); }
    });

    if (pwTouch()) {
      var sx = null;
      win.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      win.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) pwStep(win, dx < 0 ? 1 : -1);
      });
    } else {
      var bar = win.querySelector('.pw-bar'), drag = null;
      bar.addEventListener('pointerdown', function (e) {
        if (e.target.closest('.pw-b')) return;
        drag = { x: e.clientX - win.offsetLeft, y: e.clientY - win.offsetTop };
        bar.setPointerCapture(e.pointerId);
        win.classList.add('pw-drag');
      });
      bar.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var vw = document.documentElement.clientWidth || window.innerWidth || 0;
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var maxX = Math.max(4, vw - win.offsetWidth - 4);
        var minY = window.scrollY + 4;
        var maxY = window.scrollY + Math.max(4, vh - 48);
        win.style.left = Math.min(Math.max(4, e.clientX - drag.x), maxX) + 'px';
        win.style.top = Math.min(Math.max(minY, e.clientY - drag.y), maxY) + 'px';
      });
      bar.addEventListener('pointerup', function (e) {
        drag = null; win.classList.remove('pw-drag');
        try { bar.releasePointerCapture(e.pointerId); } catch (err) {}
      });
      bar.addEventListener('pointercancel', function () { drag = null; win.classList.remove('pw-drag'); });
    }
    return win;
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest('img[data-full]'); if (!img) return;
    e.preventDefault(); e.stopPropagation();
    var wrap = img.closest('[data-gal]');
    var list = (wrap && wrap !== img) ? Array.prototype.slice.call(wrap.querySelectorAll('img[data-full]')) : [img];
    var shots = list.map(function (n) { return { full: n.getAttribute('data-full'), alt: n.getAttribute('alt') }; });
    var title = ((wrap && wrap.getAttribute('data-gal')) || document.title || 'PHOTO').toUpperCase();
    pwOpen(shots, Math.max(0, list.indexOf(img)), title);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var wins = Array.prototype.slice.call(document.querySelectorAll('.pwin'));
    if (!wins.length) return;
    wins.sort(function (a, b) { return (parseInt(a.style.zIndex, 10) || 0) - (parseInt(b.style.zIndex, 10) || 0); });
    pwClose(wins[wins.length - 1]);
  });


  /* predictive search: dropdown window off /search/suggest.json. The form is a
     real GET to /search, so with JS off it still searches. */
  document.querySelectorAll('form[data-psearch]').forEach(function (form) {
    var input = form.querySelector('input[type="search"]');
    var drop = form.querySelector('.ps-drop');
    if (!input || !drop) return;
    var timer = null, idx = -1, items = [];

    function close() { drop.hidden = true; drop.innerHTML = ''; idx = -1; items = []; }
    function money(cents) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      var n = (cents / 100).toFixed(2);
      if (cur === 'EUR') return '\u20AC' + n.replace('.', ',');
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
      catch (e) { return n; }
    }
    function paint(products, q) {
      if (!products.length) {
        drop.innerHTML = '<div class="ps-bar"><span>SEARCH.EXE</span></div><div class="ps-empty">NO MATCH</div>';
        drop.hidden = false; return;
      }
      var rows = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=120" alt="" width="44" height="55">' : '<span class="ps-noimg"></span>';
        return '<a class="ps-row" href="' + p.url + '">' + img +
               '<span class="ps-nm"></span><span class="ps-pr"></span></a>';
      }).join('');
      drop.innerHTML = '<div class="ps-bar"><span>SEARCH.EXE</span><span class="wb-x">&#10005;</span></div>' + rows +
        '<a class="ps-all" href="/search?q=' + encodeURIComponent(q) + '">ALL RESULTS &#8594;</a>';
      var nodes = drop.querySelectorAll('.ps-row');
      products.forEach(function (p, i) {
        nodes[i].querySelector('.ps-nm').textContent = p.title;
        nodes[i].querySelector('.ps-pr').textContent = p.price != null ? money(parseFloat(p.price) * 100) : '';
      });
      items = Array.prototype.slice.call(drop.querySelectorAll('.ps-row,.ps-all'));
      idx = -1;
      drop.hidden = false;
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          paint(ps, q);
        })
        .catch(function () { close(); });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 200); });
    input.addEventListener('focus', function () { if (input.value.trim().length > 1) run(); });
    input.addEventListener('keydown', function (e) {
      if (drop.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx += (e.key === 'ArrowDown' ? 1 : -1);
        if (idx < 0) idx = items.length - 1;
        if (idx >= items.length) idx = 0;
        items.forEach(function (n, i) { n.classList.toggle('on', i === idx); });
        items[idx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        if (idx > -1 && items[idx]) { e.preventDefault(); window.location.href = items[idx].getAttribute('href'); }
      } else if (e.key === 'Escape') { close(); }
    });
    drop.addEventListener('click', function (e) { if (e.target.closest('.wb-x')) { e.preventDefault(); close(); } });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  });

  /* shop sort */
  document.querySelectorAll('[data-sort]').forEach(function (b) {
    b.addEventListener('click', function () {
      var mode = b.getAttribute('data-sort');
      document.querySelectorAll('.sec-body.grid').forEach(function (g) {
        var cards = Array.prototype.slice.call(g.querySelectorAll('.card'));
        cards.sort(function (x, y) {
          if (mode === 'low') return parseFloat(x.dataset.price) - parseFloat(y.dataset.price);
          if (mode === 'high') return parseFloat(y.dataset.price) - parseFloat(x.dataset.price);
          return x.dataset.name.localeCompare(y.dataset.name);
        });
        cards.forEach(function (c) { g.appendChild(c); });
      });
      var dd = b.closest('details'); if (dd) dd.open = false;
    });
  });
})();
